import {z} from 'zod';

export const BrandTranslation = z.object({
  id: z.coerce.number(),
  locale: z.string(),
  name: z.string(),
  webName: z.string().nullable(),
  description: z.string().nullable().optional(),
});

export type BrandTranslation = z.infer<typeof BrandTranslation>;
